export const areFiltersEqual = (filter1, filter2) => {
    if(filter1.key !== filter2.key) {
        return false;
    }
    if(filter1.operator !== filter2.operator) {
        return false;
    }
    if(JSON.stringify(filter1.value) !== JSON.stringify(filter2.value)) {
        return false;
    }
    return true;
}

export const isFilterApplied = (filter, appliedFilters) => {
    return appliedFilters.some(appliedFilter => areFiltersEqual(filter, appliedFilter));
}

export const areFiltersApplied = (filters, appliedFilters) => {
    return filters.every(filter => isFilterApplied(filter, appliedFilters));
}

export const applyFilter = (filter, appliedFilters) => {
    return [...appliedFilters, filter]
}

export const applyFilters = (filters, appliedFilters) => {
    return [...appliedFilters, ...filters]
}

export const removeFilter = (filter, appliedFilters) => {
    return appliedFilters.filter(appliedFilter => {
        return areFiltersEqual(filter, appliedFilter) === false;
    })
}

export const removeFilters = (filters, appliedFilters) => {
    return appliedFilters.filter((appliedFilter) => {
        return isFilterApplied(appliedFilter, filters) === false;
    })
}

export const toggleFilter = (filter, appliedFilters) => {
    if(isFilterApplied(filter, appliedFilters)) {
        return removeFilter(filter, appliedFilters);
    }
    return applyFilter(filter, appliedFilters);
}

export const toggleFilters = (filters, appliedFilters) => {
    if(areFiltersApplied(filters, appliedFilters)) {
        return removeFilters(filters, appliedFilters);
    }
    return applyFilters(filters, appliedFilters);
}

export const getQuickFilterValues = (quickFilterOptions) => {
    return quickFilterOptions.reduce((values, quickFilterOption) => {
        if(quickFilterOption.options) {
            return [...values, ...getQuickFilterValues(quickFilterOption.options)];
        }
        return [...values, quickFilterOption.value];
    }, []);
}